import React from 'react';
import styles from './Button.module.css';

export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  PRIMARY_INVERSE: 'primaryInverse',
  TERTIARY: 'tertiary',
  TERTIARY_INVERSE: 'tertiaryInverse',
  CANCEL: 'cancel',
};

const Button = (props) => {
  const {
    type,
    disabled,
    onClick,
    className,
    style,
    children,
    buttonType,
    dataTestId,
  } = props;

  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${styles.button} ${styles[buttonType]} ${className || ''}`}
      style={style}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  type: 'button',
  buttonType: BUTTON_TYPES.TERTIARY,
  dataTestId: null,
};

export default Button;
